
import { Routes } from '@angular/router';

import { HomeComponent } from './features/home/pages/home.component';

import { LoginComponent } from './features/auth/pages/login/login.component';

import { DashboardComponent } from './features/dashboard/pages/dash.component';

import { ResourcesComponent } from './features/resources/pages/resources.component';

import { TechnologiesComponent } from './features/technologies/pages/technologies.component';

import { UserRegisterComponent } from './features/user/register/user-register.component';
import { ProductsComponent } from './features/products/pages/products.component';
import { ArchitectureAnalysisComponent } from './features/products/pages/architecture-analysis.component';

import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [

  {
    path: '',
    component: HomeComponent
  },

  {
    path: 'login',
    component: LoginComponent
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard]
  },

    {
    path: 'cadastro-usuarios',
    component: UserRegisterComponent,
    canActivate: [authGuard]
  },

   {
    path: 'resources',
    component: ResourcesComponent
  },

  {
    path: 'technologies',
    component: TechnologiesComponent
  },

  {
    path: 'products',
    component: ProductsComponent
  },

  {
    path: 'products/architecture-analysis',
    component: ArchitectureAnalysisComponent
  },

  {
    path: '**',
    redirectTo: ''
  }
];
